<template>
    <div class="box">
        <Header></Header>

        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="font-size: 17px;color: #482c15;font-weight: bold;">{{typefaces == 1 ? name : nameEng}}</p>
                <p style="font-size: 13px;color: #787B7D;font-weight: bold;padding-top: 15px;padding-bottom:5px;">{{time}}</p>
                <p style="font-size: 15px;color: #131313;padding-top: 10px;" v-for="(item, index) in (typefaces == 1 ? list : listEng)" :key="index">{{item}}</p>
                <img v-if="text==1" style="width: 100%;height: auto;margin-top:10px;" :src="path" alt="">
            </div>

            <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

export default {
	name: 'Details',
	components: {
		Header,
        Footer
	},
	data () {
		return {
            text: '',
            id: '',
            banner: {},
            name: '',
            nameEng: '',
            time: '',
            path: '',
            list: [],
            listEng: [],
            typefaces: 1,
            typeFacesNumber: 0
		}
	},

    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch:{
        aaa(type) {
            this.typefaces = type;
        },
    },

	mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        
        this.text = this.$route.query.text;
        this.id = this.$route.query.id;
        
        let type = '';
        if(this.text==1 || this.text==3) {
            type = 12;
        } else if(this.text == 2) {
            type = 15;
        }
        this.getData(type);
        this.getList();
	},

	methods: {

        fatherMethod(type){
            this.typefaces = type;
            this.typeFacesNumber = type;
        },

        // 获取轮播图
		getData(type) {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: type
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		},

        // 获得详情页数据
        getList() {
            axios({
				url: this.url + '/content/input/' + this.id,
				method: 'get',
				data: {
				},
			}).then( res => {
                let data = res.data.data;
                this.name = data.name;
                this.nameEng = data.nameEng;
                this.time = data.releaseTime;
                this.path = data.path;
                let text = data.text.split(/[\n]/);
                this.list = text;
                let textEng = data.textEng.split(/[\n]/);
                this.listEng = textEng;
			});
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/Details.vue